import {
  API_LOG_ACTIVITY_LIST,
  API_LOG_DASHBOARD_ACTIVITY_LIST,
  API_LOG_LIST,
  API_LOG_PEP_LIST,
} from "./apiPaths";
import axiosMiddleware from "./axiosMiddleware";

export const getUsersLogAPI = ({ limit, offset }) => {
  return axiosMiddleware({
    method: "get",
    url: `${API_LOG_LIST}?limit=${limit}&offset=${offset}}`,
  });
};
export const getPepLogsAPI = ({ limit, offset, from, to }) => {
  return axiosMiddleware({
    method: "get",
    url: `${API_LOG_PEP_LIST}?limit=${limit}&offset=${offset}&from=${from}&to=${to}`,
  });
};

export const getAdminActivityLogsAPI = ({
  limit,
  offset,
  from,
  to,
  subject,
  admin,
}) => {
  let url = `${API_LOG_ACTIVITY_LIST}?limit=${limit}&offset=${offset}&from=${from}&to=${to}`;
  if (subject) {
    url += `&subject=${subject}`;
  }
  if (admin) {
    url += `&admin=${admin}`;
  }

  return axiosMiddleware({
    method: "get",
    url: url,
  });
};

export const getDashboardActivityLogsAPI = ({
  limit,
  offset,
  from,
  to,
  subject,
  admin,
}) => {
  let url = `${API_LOG_DASHBOARD_ACTIVITY_LIST}?limit=${limit}&offset=${offset}&from=${from}&to=${to}`;
  if (subject) {
    url += `&subject=${subject}`;
  }
  if (admin) {
    url += `&admin=${admin}`;
  }

  return axiosMiddleware({
    method: "get",
    url: url,
  });
};
